import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { Controller } from 'react-hook-form';
import FormHelperText from '@mui/material/FormHelperText';
import { CommonDropDownStyle } from '../../../../ui/styled';

const TransDropdownFormInput = (props) => {
  const {
    name,
    control,
    label,
    options,
    defaultId,
    errors,
    helperText,
    disabled,
    register,
    organization,
    contact,
    source,
    outcome,
  } = props;

  const generateSingleOptions = () => {
    return options?.map((item, index) => {
      return (
        <MenuItem key={index} value={organization ? item.orgId : item.id}>
          {!contact && !organization && !source && !outcome && item.value}
          {contact && item.key}
          {organization && item.orgKey}
          {source && item.id}
          {outcome && item.dsc}
        </MenuItem>
      );
    });
  };

  return (
    <CommonDropDownStyle>
      <InputLabel>{label}</InputLabel>
      <Controller
        register={register}
        render={({ field: { onChange, value } }) => (
          <Select
            defaultValue={defaultId}
            onChange={onChange}
            value={value}
            error={errors}
            disabled={disabled}
          >
            <MenuItem value=''>
              <em>None</em>
            </MenuItem>
            {generateSingleOptions()}
          </Select>
        )}
        control={control}
        name={name}
      />
      <FormHelperText style={{ color: '#ff4d4f' }}>{helperText}</FormHelperText>
    </CommonDropDownStyle>
  );
};

export default TransDropdownFormInput;
